export const WORK_HOURS = {
  START: 7, // from 8:00
  END: 21, // until 21:00
};
